<template>
  <div class="main">
    <div class="title">捐献须知</div>

    <div class="content">
      <div class="sj">捐献造血干细胞的健康要求如同献血，即不能因捐献造血干细胞影响捐献者的健康，又不能因接受造血干细胞而使患者增加新的疾病。</div>
      <div class="sj">如有以下情况则不能报名参加捐献造血干细胞捐献：</div>
      <div class="sj">性病、艾滋病患者及艾滋病病毒感染者；</div>
      <div class="sj">乙肝、丙肝患者以及乙肝丙肝病毒携带者；</div>
      <div class="sj">过敏性疾病及反复发作过敏者；</div>
      <div class="sj">各种结核病患者以及患自身免疫性疾病（如红斑狼疮、硬皮病等）；</div>
      <div class="sj">心血管疾病患者、如各种心脏病、高血压、心肌炎等；</div>
      <div class="sj">严重呼吸系统疾病及消化系统疾病；</div>
      <div class="sj">血液病患者，如白血病、重症贫血等；</div>
      <div class="sj">做过重要器官切除手术者以及眼底有病变的高度近视者（800度以上）；</div>
      <div class="sj">患有恶性肿瘤以及影响健康的良性肿瘤；</div>
      <div class="sj">精神病患者以及内分泌疾病患者。</div>
      <div class="sj">年龄在18～45周岁，身体健康，上海市市民或常住上海的外省市公民，在征得家人的意见后，可报名参加造血干细胞捐献。</div>
      <div class="sj">捐献造血干细胞前要进行血样采集或口腔粘膜拭子样本采集，来进行人类白细胞抗原（HLA）的入库登记和匹配筛选。</div>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style lang="less" scoped>
.main {
  box-sizing: border-box;
  padding: 24px;
  width: 100vw;
  height: 100%;
  font-size: 14px;

  background-image: url("../../assets/jxxz/bg.png");
  background-size: cover;
  .title {
    margin-top: 120px;
    font-size: 30px;
    font-weight: bold;
  }

  .content {
    margin-top: 16px;

    padding: 25px;
    background-color: #fef2f4;
    border-radius: 10px;
  }
}
</style>